import {
  FETCH_CURRENT_SUBSCRIPTION,
  FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
  FETCH_PLANS,
  FETCH_PLANS_SUCCESS,
  FETCH_INVOICE_INFO,
  FETCH_INVOICE_INFO_SUCCESS,
  CALCULATE_PRICE,
  CALCULATE_PRICE_SUCCESS,
  VALIDATE_COUPON,
  VALIDATE_COUPON_SUCCESS,
  CLEAR_COUPON,
  PURCHASE_SUBSCRIPTION,
  PURCHASE_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_HISTORY,
  FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
  SCHEDULE_DOWNGRADE,
  SCHEDULE_DOWNGRADE_SUCCESS,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  SET_PAYMENT_REQUIRED,
  CLEAR_PAYMENT_REQUIRED,
  SUBSCRIPTION_API_ERROR,
  SET_SUBSCRIPTION_RESOLVED,
} from "./actionTypes"

export const fetchCurrentSubscription = () => ({
  type: FETCH_CURRENT_SUBSCRIPTION,
})

export const setSubscriptionResolved = () => ({
  type: SET_SUBSCRIPTION_RESOLVED,
})

export const fetchCurrentSubscriptionSuccess = (data) => ({
  type: FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
  payload: data,
})

export const fetchPlans = () => ({
  type: FETCH_PLANS,
})

export const fetchPlansSuccess = (data) => ({
  type: FETCH_PLANS_SUCCESS,
  payload: data,
})

export const fetchInvoiceInfo = () => ({
  type: FETCH_INVOICE_INFO,
})

export const fetchInvoiceInfoSuccess = (data) => ({
  type: FETCH_INVOICE_INFO_SUCCESS,
  payload: data,
})

export const calculatePrice = (payload) => ({
  type: CALCULATE_PRICE,
  payload,
})

export const calculatePriceSuccess = (data) => ({
  type: CALCULATE_PRICE_SUCCESS,
  payload: data,
})

export const validateCouponAction = (payload) => ({
  type: VALIDATE_COUPON,
  payload,
})

export const validateCouponSuccess = (data) => ({
  type: VALIDATE_COUPON_SUCCESS,
  payload: data,
})

export const clearCoupon = () => ({
  type: CLEAR_COUPON,
})

export const purchaseSubscription = (payload, history) => ({
  type: PURCHASE_SUBSCRIPTION,
  payload: { data: payload, history },
})

export const purchaseSubscriptionSuccess = (data) => ({
  type: PURCHASE_SUBSCRIPTION_SUCCESS,
  payload: data,
})

export const fetchSubscriptionHistory = () => ({
  type: FETCH_SUBSCRIPTION_HISTORY,
})

export const fetchSubscriptionHistorySuccess = (data) => ({
  type: FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
  payload: data,
})

export const scheduleDowngradeAction = (targetPlanId, reason) => ({
  type: SCHEDULE_DOWNGRADE,
  payload: { targetPlanId, reason },
})

export const scheduleDowngradeSuccess = (data) => ({
  type: SCHEDULE_DOWNGRADE_SUCCESS,
  payload: data,
})

export const cancelSubscription = (reason) => ({
  type: CANCEL_SUBSCRIPTION,
  payload: { reason },
})

export const cancelSubscriptionSuccess = (data) => ({
  type: CANCEL_SUBSCRIPTION_SUCCESS,
  payload: data,
})

export const setPaymentRequired = (data) => ({
  type: SET_PAYMENT_REQUIRED,
  payload: data,
})

export const clearPaymentRequired = () => ({
  type: CLEAR_PAYMENT_REQUIRED,
})

export const subscriptionApiError = (error) => ({
  type: SUBSCRIPTION_API_ERROR,
  payload: error,
})
